export default {
}



// WEBPACK FOOTER //
// ./src/store/getters.js